import VectorSource from 'ol/source/Vector';
import { TopoJSON } from 'ol/format';
import { createInstanceFactory } from '@tmapy/utils';
import { ManagedGeoJSON } from './ManagedGeoJSON';
const createVectorSource = (options) => {
    switch (options.format) {
        case 'geojson': {
            return new VectorSource({
                ...options,
                format: new ManagedGeoJSON({
                    dataProjection: options.dataProjection,
                    featureProjection: options.featureProjection,
                }, options.layerId),
            });
        }
        case 'topojson': {
            return new VectorSource({
                ...options,
                format: new TopoJSON({
                    dataProjection: options.dataProjection,
                }),
            });
        }
        case 'empty': {
            return new VectorSource();
        }
        default: {
            throw new Error(`[vectorSourceFactory] unknown format: ${options.format}`);
        }
    }
};
export const vectorSourceFactory = createInstanceFactory(createVectorSource);
//# sourceMappingURL=vectorSourceFactory.js.map